export class TemplateImageInspectionInput {
    description = '';
    constructor(imageInspection) {
        if (imageInspection) {
            this.description = imageInspection.description;
        }
    }
}
